import '../../styles/sections/section-steps.scss'
import $ from 'jquery'
import 'slick-carousel'
import {register} from "@shopify/theme-sections"


export default register(
    `section-steps`,
    {
        onLoad() {
            $(`.steps-block-slider`).not(`.slick-initialized`).each(function () {
                $(this).slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    responsive: [
                        {
                            breakpoint: 900,
                            settings: {
                                slidesToShow: 1,
                                arrows: true,
                                dots: true
                            }
                        }
                    ]
                })
            })
        },
        /**
         * Event callback for Theme Editor `section:unload` event
         */
        onUnload() {
        },
    }
)
